export enum ConnectionSource {
  PLAID = 'PLAID',
  GUSTO = 'GUSTO',
  SHOPIFY = 'SHOPIFY',
  STRIPE = 'STRIPE',
  SQUARE = 'SQUARE',
  PAYPAL = 'PAYPAL',
  AMAZON = 'AMAZON',
}

export enum ConnectionState {
  CONNECTED = 'CONNECTED',
  DELETED = 'DELETED',
  REMOVED_FROM_SOURCE = 'REMOVED_FROM_SOURCE',
  INVALID = 'INVALID',
  ITEM_LOGIN_REQUIRED = 'ITEM_LOGIN_REQUIRED',
  ITEM_NOT_SUPPORTED = 'ITEM_NOT_SUPPORTED',
  MFA_NOT_SUPPORTED = 'MFA_NOT_SUPPORTED',
  INVALID_MFA = 'INVALID_MFA',
  NO_ACCOUNTS = 'NO_ACCOUNTS',
  NOT_READY = 'NOT_READY',
  MISSING_PERMISSIONS = 'MISSING_PERMISSIONS',
  INCOMPLETE = 'INCOMPLETE',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  ITEM_LOCKED = 'ITEM_LOCKED',
  USER_SETUP_REQUIRED = 'USER_SETUP_REQUIRED',
  CONNECTION_NO_SUPPORTED = 'CONNECTION_NO_SUPPORTED',
  INSUFFICIENT_CREDENTIALS = 'INSUFFICIENT_CREDENTIALS',
  TEMP_ERROR = 'TEMP_ERROR',
  CONNECTION_NEEDS_UPDATE = 'CONNECTION_NEEDS_UPDATE',
  CONNECTION_DISABLED = 'CONNECTION_DISABLED',
  CONNECTION_LINK_ERROR = 'CONNECTION_LINK_ERROR',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
}

export enum AccountType {
  BANK = 'BANK',
  CREDITCARD = 'CREDITCARD',
}

export enum UsageType {
  PERSONAL_USED_FOR_BUSINESS = 'PERSONAL_USED_FOR_BUSINESS',
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS',
}

export type Balance = {
  amount: number;
  sourceSyncTime: string;
  date: string | undefined | null;
};

export type Ledger = {
  id: string;
  name: string | undefined | null;
  role: string | undefined | null;
  referenceBalance: Balance[];
  latestValidBalance: Balance[];
  latestInvalidBalance: Balance[];
};

type Transaction = {
  date: string;
};

export type Account = {
  id: string;
  name: string | null | undefined;
  isPersonal: boolean;
  isActive: boolean;
  number: string | null | undefined;
  type: keyof typeof AccountType;
  sourceId: string;
  defaultCurrency: string | null | undefined;
  isMultiCurrency: boolean;
  isRemovedFromSource: boolean;
  clientUsageType: keyof typeof UsageType;
  sourceSyncDateTime: string | undefined | null;
  latestTransactions: {
    data: Transaction[];
  };
  earliestTransactions: {
    data: Transaction[];
  };
  balances: {
    data: Balance[];
  };
  ledger: Ledger | null | undefined;
};

export type Connection = {
  id: string;
  financialInstitutionName: string | null | undefined;
  state: ConnectionState;
  source: keyof typeof ConnectionSource;
  institutionId: string | null;
  isSyncing: boolean;
  sourceId: string;
  accounts: Account[];
  earliestSyncDate?: string;
};

export enum Role {
  'BANK_ACCOUNT' = 'BANK_ACCOUNT',
  'CREDIT_CARD' = 'CREDIT_CARD',
  'EQUITY_ACCOUNT' = 'EQUITY_ACCOUNT',
  'STATEMENT_PROCESSING_ACCOUNT' = 'STATEMENT_PROCESSING_ACCOUNT',
}

export type LedgerAccount = {
  id: string;
  active: boolean;
  name: string;
  role: keyof typeof Role | undefined | null;
  category: {
    id: string;
  };
  accountSettings: {
    fdsAccountId: string | undefined | null;
  };
};

export const NEW_INTEGRATION_SOURCES = [
  ConnectionSource.STRIPE,
  ConnectionSource.SQUARE,
  ConnectionSource.PAYPAL,
  ConnectionSource.AMAZON,
];
